import React from 'react'
import '../css/Contact.css'

function Contact() {
  return (
    <div>Contact</div>
  )
}

export default Contact